<template>
  <div>
    <div class="form-phone-verified-phone">
      <el-input placeholder="输入手机号"
        class="form-phone-verified-phone-input"
        v-model="phone"
        ref="phoneRef"
        @change="onPhoneChange"/>
      <el-button class="form-phone-verified-phone-button"
        :disabled="countDown > 0"
        @click="sendCode">{{countDown > 0 ? countDown + '秒后重试' : '发送验证码'}}</el-button>
    </div>

    <el-input class="form-phone-verified-code"
      placeholder="输入短信验证码"
      ref="code"
      v-model="code"
      @change="onCodeChange"/>
  </div>
</template>

<script>
export default {
    name: 'TicketFormPhoneVerified',

    props : ['item', 'value'],

    data() {
      return {
        phone : null,
        code : null,
        codeVerifyOk: false,
        countDown: 0
      }
    },

    mounted() {
      if ( !!this.value ) {
        this.phone = this.value;
      }
    },

    watch: {
      value() {
        if ( !!this.value ) {
          this.phone = this.value;
        }
      }
    },

    methods: {
      onPhoneChange() {
        this.$emit('input', this.phone);
        this.$emit('change', this.phone);
      },

      shadowRequired(value) {
        if(value) {
          this.$refs.phoneRef.$el.classList.add('shadow-required');
          return;
        }

        this.$refs.phoneRef.$el.classList.remove('shadow-required');
      },

      validation() { // 供 TicketTaskForm.vue validation 调用
        console.log('#52 validation', this);

        if ( this.codeVerifyOk ) {
          this.$refs.code.$el.classList.remove('shadow-required');
          return true; // 校验通过
        }

        // 请输入验证码
        _message('请输入正确的验证码');

        this.$refs.code.$el.classList.add('shadow-required');
        return false;
      },

      // https://www.itaojin.cn/merchant/action/register/sendSms?newPhone=true
      sendCode() {
        if ( !this.phone || !(/^1\d{10}$/.test(this.phone))) {
          _message('请输入有效的手机号');
          return;
        }

        var _this = this;

        _this.countDown = 30; // 倒计时30秒

        var intervalId = setInterval(() => {
          _this.countDown = _this.countDown - 1;
          if ( _this.countDown < 1 ) {
            clearInterval(intervalId); // 结束倒计时
          }
        }, 1000);

        // 调接口 发短信
        sdk.SmsCodeApi().sendSmsCode({
          phone: _this.phone
        }).then(res => {
          console.log('#70 sendSmsCode', res, _this);

          if(res) {
            _message("短信验证码发送成功")
            return;
          }

          _alert('短信验证码发送失败,请稍后再试; 或联系我们 http://s.itaojin.cn/ticket/h');
        });
      },

      // 输入后 change 就校验 把校验结果存为变量
      onCodeChange() {
        var _this = this;

        sdk.SmsCodeApi().verifySmsCode({
          phone: _this.phone,
          code: _this.code
        }).then(res => {
          console.log('#83 verifySmsCode', res, _this);
          _this.codeVerifyOk = res;
        });
      }
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketFormPhoneVerified.vue